import React from 'react';

// Layout
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Sections
import Hero from './components/Hero';
import AboutMe from './components/home/AboutMe';
import Stats from './components/Stats';
import TechStack from './components/TechStack';
import ProblemSection from './components/ProblemSection';
import DebugSection from './components/DebugSection';
import ContactCTA from './components/ContactCTA';

// Projects section — untouched as per requirement
import { ProjectsSection } from './components/projects/ProjectsSection';

/**
 * App.tsx — Portfolio homepage orchestrator.
 *
 * Sections (in order):
 *   1. Hero          — headline, role, CTAs
 *   2. Stats         — experience cards + timeline + education
 *   3. TechStack     — tech grid + proficiency bars
 *   4. ProjectsSection — "System Design Lens" (DO NOT MODIFY)
 *   5. ProblemSection — DSA problems with approach + complexity
 *   6. DebugSection  — real-world bug cases + before/after code
 *   7. ContactCTA    — contact form + info
 */
const App: React.FC = () => (
  <div className="min-h-screen bg-[#0a0a0f] text-white antialiased">
    {/* Sticky navigation */}
    <Navbar />

    {/* ── 1. Hero ─────────────────────────────────────────── */}
    <Hero />
   
    {/* ── 1. Hero ─────────────────────────────────────────── */}
    <AboutMe />

    {/* ── 2. Experience & Education ───────────────────────── */}
    <Stats />

    {/* ── 3. Tech Stack ───────────────────────────────────── */}
    <TechStack />

    {/* ── 4. Projects ─────────────────────────────────────── */}
    <ProjectsSection />

    {/* ── 5. Problem Solving / DSA ────────────────────────── */}
    <ProblemSection />

    {/* ── 6. Bug Fixing / Debugging ───────────────────────── */}
    <DebugSection />

    {/* ── 7. Contact CTA ──────────────────────────────────── */}
    <ContactCTA />

    {/* Footer */}
    <Footer />
  </div>
);

export default App;
